import React, { useRef, useEffect, useState } from "react";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler,
);

function CAGR({ current_year, current_revenue, chart_data }) {
  const chartRef = useRef(null);
  const [gradientFill, setGradientFill] = useState(null);
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    if (!chartRef.current) return;

    const ctx = chartRef.current.ctx;
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "rgba(180, 242, 34, 0.4)");
    gradient.addColorStop(1, "rgba(180, 242, 34, 0)");
    setGradientFill(gradient);
  }, []);

    let userLoging = {};
    let currencies = [];
    userLoging = JSON.parse(localStorage.getItem("user") || "{}");
    currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
    const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
    const selectedCurrency = currencies.find(
    (currency) =>
      Number(currency.value) === defaultCurrencyId
  );
    const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
    const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;
    const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";

  useEffect(() => {
    const newLabels = [];
    const newValues = [];

    chart_data?.forEach((item) => {
      newLabels.push(item.financial_year);
      newValues.push(item.total.toFixed(0));
    });
    if (current_year) {
      newLabels.push(current_year?.slice(0, 4));
      newValues.push((current_revenue / amountDivisor).toFixed(0));
    }

    setLabels(newLabels);
    setValues(newValues);
  }, [chart_data]);

  const data = {
    labels,
    datasets: [
      {
        label: `Revenue (${amountSuffix})`,
        data: values,
        borderColor: "#6ece0fff",
        backgroundColor: gradientFill,
        fill: true,
        borderWidth: 2,
        tension: 0.4,
        pointRadius: 12,
        pointHoverRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: { display: false },
    },
    elements: {
      line: { borderWidth: 2, tension: 0.4 },
      point: {
        radius: 6, // visible points
        hoverRadius: 8, // hover effect
        display: true,
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: {
        grid: { display: false },
        ticks: {
          callback: (value) => value + amountSuffix,
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "350px" }}>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
}

export default CAGR;
